import React from "react";
import * as Scrivito from "scrivito";
import { BackgroundWrapper, ObjValidator } from "components";
import type { ObjValidatorProps } from "interfaces/shared.types";
import LoginView from "./SubComponents/LoginView";
import ResetView from "./SubComponents/ResetView";
import SetPassView from "./SubComponents/SetPassView";
import ChangePassView from "./SubComponents/ChangePassView";
import { SelectLanguageView } from "./SubComponents/SelectLanguageView";

const LoginPage = Scrivito.connect(({ page }: ObjValidatorProps) => {
  const pageParams = Scrivito.currentPageParams() || { view: "login" };
  if (!page) return;

  if (typeof localStorage === "undefined") {
    return (
      <BackgroundWrapper page={page}>
        <div className="py-10">
          <div className="bg-white col-md-6 mx-auto px-2 py-5">
            <Scrivito.ContentTag
              tag="h1"
              attribute="errorLoginStorage"
              content={page}
            />
          </div>
        </div>
      </BackgroundWrapper>
    );
  }

  const { view } = pageParams;

  let currentView;
  if (view === "resetPass") {
    currentView = <ResetView page={page} />;
  } else if (view === "forgotPass") {
    currentView = <SelectLanguageView page={page} />;
  } else if (view === "newAccount") {
    currentView = <SelectLanguageView page={page} />;
  } else if (view === "setPass") {
    currentView = <SetPassView page={page} />;
  } else if (view === "changePass") {
    currentView = <ChangePassView page={page} />;
  } else {
    currentView = <LoginView page={page} />;
  }

  return (
    <BackgroundWrapper page={page}>
      <div className="py-10">{currentView}</div>
    </BackgroundWrapper>
  );
});

const CheckedPage = (props: ObjValidatorProps) => (
  <ObjValidator {...props}>
    <LoginPage {...props} />
  </ObjValidator>
);

export default CheckedPage;
Scrivito.provideComponent("LoginPage", CheckedPage);
